import { render, staticRenderFns } from "./emailDialogComponent.vue?vue&type=template&id=fdfb71f2"
import script from "./emailDialogComponent.vue?vue&type=script&lang=js"
export * from "./emailDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports